import axiosInstance from '../../utils/axios';
import { Appointment } from '../adapters/appointmentAdapter';

export const appointmentsService = {
  async getAppointments(location?: string): Promise<Appointment[]> {
    const params = location ? { location } : undefined;
    const response = await axiosInstance.get('/api/v1/appointments', { params });
    return response.data;
  },

  async getPrivateAppointments(location: string): Promise<Appointment[]> {
    const response = await axiosInstance.get(`/api/v1/appointments/private?location=${location}`);
    return response.data;
  }
};
